var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('AboutPart',{attrs:{"about-desc":[
      {
        icon: 'bulb',
        title: 'Who are we?',
        description:
          'We\'re a progressive manufacturer started in 2015 and located in Zhouzhuang Town, Jiangyin, Jiangsu, China.'
      },
      {
        icon: 'tool',
        title: 'What do we do?',
        description:
          'We produce products which contribute to hearing protection and had already been sold to North America, Europe and many other countries and regions.'
      },
      {
        icon: 'safety-certificate',
        title: 'What do we want?',
        description:
          'We want to cooperate with you to achieve success by selling products and make hearing protection easier.'
      }
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }